<template>
  <div class="login">
    <card header-text="Iniciar sesión">
      <div class="card-body card-block">
        <formio
          ref="loginFormio"
          :form="loginFormio"
          :options="optionsFormioLogin"
          @submit="onSubmit"
          @error="onError"
        >
        </formio>
        <span style="position: absolute; float: right; margin-top: -12px;"><router-link :to="{ name: 'restorePassword' }"><small>Olvidé mi contraseña</small></router-link></span>
      </div>
    </card>
  </div>
</template>

<script>
import { Form } from 'vue-formio'
import loginFormio from './formio'

export default {
  name: 'Login',
  components: { formio: Form },
  data () {
    return {
      loading: false,
      optionsFormioLogin: {
        noAlerts: true
      }
    }
  },
  watch: {
    $route: {
      handler: function (route) {
        this.redirect = route.query && route.query.redirect
      },
      immediate: true
    }
  },
  methods: {
    onSubmit (form) {
      this.login({ username: form.data.email, password: form.data.password })
    },
    onError (err) {
      console.error(err)
    },
    login (credentials) {
      this.$store.dispatch('user/login', credentials).then((response) => {
        this.$router.push({ path: this.redirect || '/' })
      }).catch((err) => {
        if (err.code === 'auth/wrong-password') {
          alert('Contraseña errónea')
        } else if (err.code === 'auth/user-not-found') {
          alert('Usuario no existe')
        }
        this.loading = false
      })
    }
  },
  computed: {
    loginFormio () {
      return loginFormio
    }
  }
}
</script>

<style lang="scss" scoped>
  .card-title{
    padding-left: 20px;
  }
</style>
